/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RealizationSavingDashboardSortCriteria {
    getFixupPrototypeFunction() { return RealizationSavingDashboardSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<RealizationSavingDashboardSortCriteria>): RealizationSavingDashboardSortCriteria {
        let obj = Object.assign(new RealizationSavingDashboardSortCriteria(), model);
        RealizationSavingDashboardSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RealizationSavingDashboardSortCriteria>): RealizationSavingDashboardSortCriteria {
        if (!model) return null;
        return RealizationSavingDashboardSortCriteria.newInstance(<RealizationSavingDashboardSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RealizationSavingDashboardSortCriteria) {
        if (!obj) return;

        models.RealizationSavingDashboardSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RealizationSavingDashboardSortCriteria): boolean {
        Object.setPrototypeOf(obj, RealizationSavingDashboardSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.RealizationSavingDashboardSortColumn;

    ascending: boolean;

}
